var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoGJ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 61,
    viewBox: "0 0 122 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#335466",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 24.778h15.453m-7.702-7.698v15.453M47.319 29.984c5.334.465 6.16.437 6.16 1.81 0-.005 0 0 0 0V40.7c0 1.908.182 6.696-7.207 6.9-10.203.281-9.294-16.162-9.294-16.162s-.104-18.372 9.372-18.424c8.615-.038 12.89 11.673 12.89 14.76V13.13s-2.453 5.163-3.306 5.163c-.504 0-3.59-5.266-9.584-5.266-5.984 0-15.443 6.06-15.443 18.41 0 12.412 8.678 16.014 15.262 16.162 6.084.138 7.44-4.666 10.476-4.666 2.906 0 3.138 4.757 3.138 5.055V31.794v.008c0-1.363.917-1.366 6.097-1.818H47.319z",
    stroke: "#335466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.143 12.2-.02.575h.02l4.991.312h.015c1.412.012 1.969.499 2.235.956.266.458.223.907.223.907l-.003.015v.015l.015 26.745s-.022 1.446-.6 2.88c-.288.716-.712 1.422-1.33 1.942-.606.511-1.4.849-2.482.86l-.064.002c-.082 0-.17-.01-.255-.015-.106-.004-.21-.009-.313-.02a6.722 6.722 0 0 1-1.605-.396c-1.052-.437-1.91-1.16-2.559-1.967a7.004 7.004 0 0 1-1.137-1.997c-.15-.423-.22-.81-.23-1.123.454.371 1.251.843 2.588.843 1.18 0 2.19-.398 2.899-1.105.709-.708 1.107-1.719 1.107-2.9 0-2.377-1.804-4.04-4.03-4.04-1.154 0-2.297.349-3.15 1.181-.851.833-1.391 2.136-1.391 3.96v.644l.05-.045c.178 2.329 1.339 4.174 2.83 5.444 1.04.886 2.231 1.5 3.37 1.829a6.185 6.185 0 0 0 .617.153 6.147 6.147 0 0 0 1.02.12c.068.001.132.012.201.012.018 0 .034-.005.052-.005 2.322-.009 5.014-.492 7.165-1.742 2.17-1.261 3.782-3.343 3.782-6.415V14.968s-.036-.438.236-.887c.271-.45.835-.93 2.234-.942h.02l4.42-.364h.005l.024-.003-.024-.572H70.143z"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#335466",
    x: 0.5,
    y: 0.5,
    width: 121,
    height: 60,
    rx: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoGJ);
export default __webpack_public_path__ + "static/media/kundenlogo-g-j.29a1b616e4071c937533b0634d2a6d80.svg";
export { ForwardRef as ReactComponent };